import { SortBy } from "tea-component/lib/table/addons";

interface SortsType extends SortBy {
  handleCard: 'base_scenario' | 'conservative_scenario' | '',
}

const BASE_SCENARIO = 'base_scenario';
const CONSERVATIVE_SCENARIO = 'conservative_scenario';

const DOWNLOAD_LOG_MAP: any = {
  '1_base_scenario': 'STUDIO_OVERALL_FINANCE_FORECAST_BASE_SCENARIO_CSV_SUBMIT',
  '2_base_scenario': 'STUDIO_OVERALL_FINANCE_FORECAST_BASE_SCENARIO_EXCEL_SUBMIT',
  '1_conservative_scenario': 'STUDIO_OVERALL_FINANCE_FORECAST_CONSERVATIVE_SCENARIO_CSV_SUBMIT',
  '2_conservative_scenario': 'STUDIO_OVERALL_FINANCE_FORECAST_CONSERVATIVE_SCENARIO_EXCEL_SUBMIT',
};

const DEFAULT_SORTS: SortsType = {
  by: '',
  order: 'asc',
  handleCard: '', // 操作的哪个卡片，和后端接口参数对应
};

export {
  DOWNLOAD_LOG_MAP,
  DEFAULT_SORTS,
  BASE_SCENARIO,
  CONSERVATIVE_SCENARIO,
}
